export default function loadGoogleFontForMicrosite(fontFamily: string) {
  const id = `microsite-google-font-${fontFamily.replace(/\s+/g, '-')}`;

  // Prevent loading the same font multiple times.
  if (document.getElementById(id)) {
    return;
  }

  const link = document.createElement('link');
  link.id = id;
  link.href = `https://fonts.googleapis.com/css2?${new URLSearchParams({
    family: `${fontFamily}:wght@400;600`,
    display: 'swap',
  }).toString()}`;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
}
